module.exports = __webpack_public_path__ + "static/media/check.f053dbdd.svg";